import fetch from '../config/fetchV2'

export const serviceQuestEvaluate = data => fetch('/service_quests/evaluate', data, 'POST')
export const serviceQuestDone = data => fetch('/service_quests/done', data, 'POST')
export const createServiceQuestResponse = data => fetch('/service_quests/response', data, 'POST')
export const serviceQuestRollbackV2 = data => fetch('/service_quests/rollback', data, 'POST')
export const serviceQuestSetApproval = data => fetch('/service_quests/set_approval', data, 'POST')
export const serviceQuestApprove = data => fetch('/service_quests/approve', data, 'POST')

export const approveCustomerOrderV2 = data => fetch('/customer_orders/' + data.id + '/approve', data, 'PUT')
